import { call, put, takeEvery } from "redux-saga/effects";
import {
  GET_MERCHANT_PERMISSION, GET_MERCHANT_SUBMERCHANTID, GET_MERCHANT_PERMISSION_BYMERCHANTID,
} from "./actionTypes"

import {
  getMerchantPermissionSuccess,
  getMerchantSubMerchantIdSuccess,
  merchantPermissionApiError
} from "./actions"

import {
  getMerchantPermissionByUserName,
  getSubMerchantIdByUserName,
  getMerchantPermissionByMerchantId
} from "../../helpers/backend_helper/backend_helper"

function* onGetMerchantPermissionList({ payload: userName }) {
  try {
    const response = yield call(getMerchantPermissionByUserName,userName)
    yield put(getMerchantPermissionSuccess(response))
  } catch (error) {
    yield put(merchantPermissionApiError(error))
  }
}


function* onGetSubMerchantIdList({ payload: userName }) {
  try {
    const response = yield call(getSubMerchantIdByUserName,userName)
    yield put(getMerchantSubMerchantIdSuccess(response))
  } catch (error) {
    yield put(merchantPermissionApiError(error))
  }
}

function* onGetMerchantPermissionListByMerchantId({ payload: merchantId }) {
  try {
    const response = yield call(getMerchantPermissionByMerchantId, merchantId)
    yield put(getMerchantPermissionSuccess(response))
  } catch (error) {
    yield put(merchantPermissionApiError(error))
  }
}

function* merchantPermissionSaga() {
    yield takeEvery(GET_MERCHANT_PERMISSION,onGetMerchantPermissionList)
    yield takeEvery(GET_MERCHANT_SUBMERCHANTID,onGetSubMerchantIdList)
    yield takeEvery(GET_MERCHANT_PERMISSION_BYMERCHANTID,onGetMerchantPermissionListByMerchantId)
}

export default merchantPermissionSaga